import Skeleton, { SkeletonCard } from './Skeleton';

/**
 * RouteFallback — content-area placeholder shown while a lazily-loaded page
 * chunk is being fetched. Sits inside the dashboard chrome (Suspense fallback in
 * DashboardShell), so the sidebar/navbar stay put and only the routed content
 * shimmers. Mirrors the common page shape: a header, a stat row, then cards.
 */
export default function RouteFallback() {
  return (
    <section className="space-y-8" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading page…</span>

      {/* Page header */}
      <div className="space-y-3">
        <Skeleton className="h-4 w-24 rounded-md" />
        <Skeleton variant="title" className="w-1/3" />
        <Skeleton className="h-4 w-2/3 rounded-md" />
      </div>

      {/* Stat row */}
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-28 rounded-2xl" />
        ))}
      </div>

      {/* Content cards */}
      <div className="grid gap-6 lg:grid-cols-3">
        <SkeletonCard className="lg:col-span-2" />
        <SkeletonCard />
      </div>
    </section>
  );
}
